import { useCallback, useEffect, useState } from 'react';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { getFeeDistributionRecords } from 'src/shared/services/feeDistributionService';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { FeeDistributionRecord } from '../models/feeDistribution';

/** Tidigare låsta fördelningsunderlag för en fakturagrupp, nyast först. */
export const useFetchFeeDistributionRecords = (ownerId?: number) => {
  const [records, setRecords] = useState<FeeDistributionRecord[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const isMounted = useIsMounted();

  const fetchData = useCallback(async () => {
    if (!ownerId || ownerId === 0) {
      setRecords([]);
      return;
    }

    setIsLoading(true);

    try {
      const res = await getFeeDistributionRecords(ownerId);
      if (isMounted() && res) {
        setRecords(res.data);
      }
    } catch (error) {
      ConsoleHelper.log(error);
      if (isMounted()) {
        setRecords([]);
      }
    } finally {
      if (isMounted()) {
        setIsLoading(false);
      }
    }
  }, [isMounted, ownerId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { records, isLoading, fetchData };
};
